import { Box, Container, Grid } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Videostore from "./videostore";



const VideostoreRoutes = () => {
  return (
    <Box sx={{
      flexGrow: 1,
      minHeight: "100vh",
      overflow: "auto",
    }}>
      <Container maxWidth="lg" sx={{ paddingTop: 4, paddingBottom: 4, paddingRight: 3, paddingLeft: 3 }}>
        <Grid container spacing={3}>
          <Routes>
            <Route index element={<Videostore />} />
          </Routes>
        </Grid>
      </Container>
    </Box>
  );
};

export default VideostoreRoutes;
